import { useEffect, useRef, useState } from 'react';

import { ONE_SECOND_IN_MILISECONDS } from 'constants/timers';

function useCountdown(
  time: number,
  { interval = ONE_SECOND_IN_MILISECONDS } = {},
) {
  const timer = useRef<number | null>(null);
  const [timeLeft, setTimeLeft] = useState(time);
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    timer.current = window.setInterval(
      () => setTimeLeft((timeLeft: number) => timeLeft - interval),
      interval,
    );

    return () => {
      if (timer.current !== null) {
        clearInterval(timer.current);
      }
    };
  }, [interval]);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsDone(true);
      if (timer.current !== null) {
        clearInterval(timer.current);
      }
    }
  }, [timeLeft]);

  return { timeLeft, isDone };
}

export { useCountdown };
